export default __webpack_public_path__ + "static/media/brand.828c7f06.svg";